import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";

import { memo, useState } from "react";
// import InfoIcon from "@mui/icons-material/Info";
import CallIcon from "@mui/icons-material/Call";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ModalPDF from "../../components/ModalPDF";

const CardSeguros = ({ contenido }) => {

  const isMobile = useMediaQuery("(max-width:600px)");
  const [openModal, setOpen] = useState(false);
  const [currentPdf, setCurrentPdf] = useState(null);
  const handleOpenModal = (archivo) => {
    setCurrentPdf(archivo);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const categorias = [
    contenido.tipo,
    contenido.subtipo,
    contenido.subtipo_1,
  ].filter(Boolean);

  const descripciones = [
    contenido.subtitulo,
    contenido.subtitulo_2,
    contenido.subtitulo_3,
  ].filter(Boolean);

  const infoButtonStyles = {
  minWidth: "unset",
  width: "20%",
  borderRadius: "12px",
  textTransform: "none",
  fontWeight: 700,
  fontSize: { xs: "8.4px", md: "10px" },
  border: "2px solid #06C7F9",
  background: "#06C7F9",
  color: "#FFF",
  transition: ".30s",
  "&:hover": {
    color: "#06C7F9",
    background: "transparent", // Nota: suele ser útil limpiar el fondo en el hover si cambias el color del texto, o puedes ajustarlo a tu gusto
    transform: "translateY(-3px)",
    boxShadow: "0 10px 25px rgba(6,199,249,.30)",
  },
};

  return (
    <Box sx={{
      width: "100%",
      display: "flex",
      justifyContent: "center",
    }}>

      <Card
        elevation={0}
        sx={{
          height: {xs: "680px", md:"650px"},
          maxWidth: "420px",
          width: "100%",
          borderRadius: "20px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          background: "linear-gradient(180deg,#ffffff 0%,#fbfbfb 100%)",
          boxShadow: "0px 18px 45px rgba(0,0,0,.16)",
          border: "1px solid #E8E8E8",
          transition: ".35s",
          position: "relative",

          "&:hover": {
            transform: "translateY(-8px)",
            boxShadow: "0px 18px 45px rgba(0,0,0,.55)",
            border: "1.5px solid #06C7F9",
          },

          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "6px",
            background:
              "linear-gradient(90deg,#06C7F9,#0A89FF)",
          },
        }}
      >
        {/* === ENCABEZADO === */}

        <Box sx={{
          pt: 4,
          px: 3,
          pb: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          background: "linear-gradient(180deg,#F9FDFF 0%,#FFFFFF 100%)",
        }}>
          <CardMedia
            component="img"
            image={contenido.image}
            alt={contenido.titulo}
            sx={{
              width: "125px",
              height: "125px",
              objectFit: "contain",
              transition: ".35s",

              ".MuiCard-root:hover &": {
                transform: "scale(1.1)",
              },
            }}
          />

          <Typography
            variant="h5"
            textAlign="center"
            sx={{
              mt: 1,
              fontWeight: 700,
              color: "#183153",
              lineHeight: 1.2,
              minHeight: 58,
          }}>
            {contenido.titulo}
          </Typography>
        </Box>

        <Divider sx={{
          borderStyle: "dashed",
          borderColor: "#D8D8D8",
        }}/>

        {/* === DESCRIPCIÓN === */}

        <CardContent sx={{
          py: 2.5,
          px: 3,
        }}>
          <Typography
            variant="overline"
            sx={{
              color: "#06C7F9",
              fontWeight: 700,
              letterSpacing: 1.5,
          }}>
            COBERTURA
          </Typography>

          <Stack
            spacing={1}
            mt={1}
          >
            {descripciones.length > 0 ? (
              descripciones.map((texto, index) => (

                <Box
                  key={index}
                  display="flex"
                  alignItems="center"
                >
                  <Box
                    sx={{
                      width: 7,
                      height: 7,
                      borderRadius: "50%",
                      bgcolor: "#06C7F9",
                      mr: 1.5,
                      flexShrink: 0,
                  }}/>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                  >
                    {texto}
                  </Typography>

                </Box>
              ))

            ) : (

              <Typography
                variant="body2"
                color="text.secondary"
              >
                Información disponible al consultar el PDF.
              </Typography>

            )}
          </Stack>
        </CardContent>

        <Divider
          sx={{
            borderStyle: "dashed",
            borderColor: "#D8D8D8",
        }}/>

        {/* === CATEGORÍAS DEL SEGURO === */}

        <CardContent
          sx={{
            pt: 2,
            pb: 2,
            px: 3,
            flexGrow: 1,
          }}
        >
          <Typography
            variant="overline"
            sx={{
              color: "#06C7F9",
              fontWeight: 700,
              letterSpacing: 1.5,
          }}>
            TIPO DE SEGURO
          </Typography>

          <Stack
            direction="row"
            spacing={1}
            useFlexGap
            flexWrap="wrap"
            mt={1.5}
          >
            {categorias.map((categoria, index) => (
              <Chip
                key={index}
                label={categoria}
                sx={{
                  bgcolor: "#EAF9FF",
                  color: "#0B5E8E",
                  fontWeight: 600,
                  borderRadius: "10px",
                  border: "1px solid #C7EEFA",
                  transition: ".30s",

                  "&:hover": {
                    bgcolor: "#06C7F9",
                    color: "#FFF",
                  },
                }}
              />
            ))}
          </Stack>

          {/* Tarjeta informativa */}

          {/* <Box
            mt={3}
            sx={{
              bgcolor: "#F8FBFD",
              border: "1px dashed #D8E4EC",
              borderRadius: "14px",
              p: 2,
          }}>
            <Typography
              variant="subtitle2"
              fontWeight={700}
              color="primary"
            >
              Atención personalizada
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              mt={0.5}
            >
              Consulta la información completa de este seguro o comunícate
              directamente con uno de nuestros asesores.
            </Typography>
          </Box> */}
        </CardContent>

        <Divider
          sx={{
            borderStyle: "dashed",
            borderColor: "#D8D8D8",
        }}/>

        {/* === ACCIONES === */}

        <CardActions
          sx={{
            p: 2,
            bgcolor: "#F5F8FB",
            borderTop: "1px solid #E5E5E5",
        }}>
          <Stack
            direction="row"
            spacing={1.4}
            width="100%"
          >
            {/* BOTÓN LLAMAR */}

            <Button
              fullWidth
              component="a"
              href={`tel:${contenido.telefonoMarcar}`}
              startIcon={<CallIcon />}
              sx={{
                minWidth: "unset",
                width: "50%",
                //py: 1.3,
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: 700,
                fontSize: {xs: "8.4px", md:"10px"},
                color: "#FFF",
                background: "linear-gradient(90deg,#00C6FB,#005BEA)",
                transition: ".30s",
                whiteSpace: "pre-line", // salto de linea en combinacion con javascript
                "&:hover": {
                  transform: "translateY(-3px)",
                  boxShadow: "0 10px 25px rgba(0,120,255,.30)",
                },
            }}>
              {contenido.telefono}
            </Button>

            {/* BOTÓN PDF FORMATO 1 --- Formato de aviso --- */}
            <Button
              fullWidth
              onClick={() => handleOpenModal(contenido.pdf_1)}
              sx={infoButtonStyles}
              >
              <PictureAsPdfIcon />
            </Button>

            {/* BOTÓN PDF FORMATO 2 --- Informe medico --- */}
            <Button
              fullWidth
              onClick={() => handleOpenModal(contenido.pdf_2)}
              sx={infoButtonStyles}
              >
              <PictureAsPdfIcon />
            </Button>

            {/* BOTÓN WHATSAPP */}
            <Button
              fullWidth
              component="a"
              href={"https://wa.me/"+contenido.whatsapp+"?text="+ encodeURIComponent(`¡Hola buen día! Me gustaría obtener más información sobre la aseguradora ${contenido.titulo}. ¿Podría brindarme información?`)}
              target="_blank"
              rel="noopener noreferrer"
              margin="0 !important"
              sx={{
                minWidth: "unset",
                width: "10%",
                //py: 1.3,
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: 700,
                fontSize: {xs: "8.4px", md:"10px"},
                border: "2px solid #25D366",
                background: "#25D366",
                color: "#FFF",
                transition: ".30s",
                whiteSpace: "pre-line", // salto de linea en combinacion con javascript
                "&:hover": {
                  color:"#000000",
                  transform: "translateY(-3px)",
                  boxShadow: "0 10px 25px rgba(0,120,255,.30)",
                },
            }}>
              <WhatsAppIcon />
            </Button>

          </Stack>
        </CardActions>
        <ModalPDF
          open={openModal}
          handleClose={handleCloseModal}
          pdfOriginal={currentPdf}
        />
      </Card>

    </Box>
  );
};

export default memo(CardSeguros);
